export default __webpack_public_path__ + "portfolio05.jpg";